__turbopack_context__.v({
  "price": "prices-module__QXq9zW__price",
  "priceMeter": "prices-module__QXq9zW__priceMeter",
  "small": "prices-module__QXq9zW__small",
  "totalArea": "prices-module__QXq9zW__totalArea",
  "wrap": "prices-module__QXq9zW__wrap",
});
